import { render, staticRenderFns } from "./RecommendationList.vue?vue&type=template&id=e2729e7c"
import script from "./RecommendationList.vue?vue&type=script&lang=js"
export * from "./RecommendationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports